import React, { useState, useEffect, useRef, useContext } from "react";
import Button from "./Button";
import Pager from "./Pager";
import Navbar from "./Navbar";
import HiddenMenuBar from "./HiddenMenuBar";
import { useFormCtx } from "../FormContext";
import Transition from "./Transition";
import AniamtedFadeBlock from "./AniamtedFadeBlock";
import * as Const from "./../_Const";
import useDarkMode from "../hooks/useDarkMode";
import useScreenType from "../hooks/useScreenType";

const PageWrapper = ({
  title,
  subtitle,
  index,
  children,
  showAppInfo,
  showTitle = true,
  animate = true,
  showNext = true,
  showSkip = false,
  skipText = "",
  onBackClick = null,
  showTitleOnNavbar = false,
}) => {
  const screenType = useScreenType();
  const [showShadow, setShowShadow] = useState(true);
  const { validate, getPageData, stepCount, navigateBackButtons, showBackButton, isDebugMode } = useFormCtx();
  const page = getPageData(index);
  const animateInit = animate ? "initial" : false;

  const nextBtnPlaceCss = "justify-self-center"; //Const.isTerminal() ? "justify-self-end" : "justify-self-center";

  const showFooter = page.showNext || showBackButton() ? true : false;
  const mtH1 = page.showSteps ? "mt-4" : "mt-8";
  const [isDarkMode] = useDarkMode();

  const isVk = Const.isVk();

  let image = isDarkMode ? "/img/logo_cekarnavmobilu_dark.png" : "/img/logo_cekarnavmobilu.png";
  if (isVk) {
    image = "/img/logo_vk_dark.png"; //isDarkMode ? "/img/logo_vk_dark.png" : "/img/logo_cekarnavmobilu.png";
  }

  const isTerminal = Const.isTerminal();
  function getEnv() {
    let env = "";
    let url = window?.location?.origin;
    //url = "https://testterminal.cekarnavmobilu.cz/";
    if (isDebugMode) {
      if (isTerminal) {
        env = " " + Const.ENV + " - TERMINAL - URL: " + url + " - API: " + Const.API_URL + " - TERMINAL_APP: " + Const.TERMINAL_APP_URL;
      } else {
        env = " " + Const.ENV + " - MOBILE - " + url + " API: " + Const.API_URL;
      }
    } else {
      if (!Const.isProduction()) {
        if (isTerminal) {
          env = " " + Const.ENV + " - TERMINAL";
        } else {
          env = " " + Const.ENV + " - MOBILE";
        }
      }
    }

    return env;
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "steps":
          css = "mt-4 mx-0";
          break;
        case "container":
          css = "container";
          break;
        case "title":
          css = "text-2xl mx-2";
          break;
        case "grid-footer":
          css = isTerminal ? "mx-4" : "grid-cols-[1fr_8fr]  mx-4";
          break;
        case "img":
          css = "100";
          break;
        case "footer-env-text":
          css = "text-[11px]";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "steps":
          css = "mt-8 mx-6";
          break;
        case "container":
          css = "max-w-7xl";
          break;
        case "title":
          css = "text-3xl mx-6";
          break;
        case "grid-footer":
          css = isTerminal ? "mx-6" : "grid-cols-[1fr_2fr]  mx-6";
          break;
        case "img":
          css = "125";
          break;
        case "footer-env-text":
          css = "text-xs";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "steps":
          css = "mt-8 mx-6";
          break;
        case "container":
          css = "container";
          break;
        case "title":
          css = "text-3xl mx-6";
          break;
        case "grid-footer":
          css = isTerminal ? "mx-6" : "grid-cols-[1fr_2fr]  mx-6";
          break;
        case "img":
          css = "125";
          break;
        case "footer-env-text":
          css = "text-xs";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "steps":
          css = "mt-8 mx-6";
          break;
        case "container":
          css = "container";
          break;
        case "title":
          css = "text-3xl mx-6";
          break;
        case "grid-footer":
          css = isTerminal ? "mx-6" : "grid-cols-[1fr_2fr]  mx-6";
          break;
        case "img":
          css = "125";
          break;
        case "footer-env-text":
          css = "text-xs";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  //console.log("xx", showTitle, showTitleOnNavbar);

  return (
    <div className="flex flex-col h-dvh overflow-hidden">
      <div className="flex-1 overflow-y-scroll pb-6">
        <Navbar onBackClick={onBackClick} customTitle={title} customSubtitle={subtitle} useCustomTitle={showTitleOnNavbar} />
        <div className={`${getCssFor("container")} mx-auto`}>
          {page.showSteps && (
            <div className={`${getCssFor("steps")}`}>
              <Pager step={page.stepIndex} stepCount={stepCount} />
            </div>
          )}
          <Transition initial={animateInit}>
            {showTitle && !showTitleOnNavbar && <h1 className={`${getCssFor("title")} text-accent-dark dark:text-accent ${mtH1}`}>{title}</h1>}
            {children}
          </Transition>
        </div>
      </div>
      {showFooter && !isTerminal && (
        <footer className={`w-full  ${showShadow && `shadow-[0_1px_17px_5px_rgba(190,228,224,1)]`}`}>
          <div className="grid grid-cols-[1fr_2fr] justify-items-stretch mx-6 mb-4 mt-4">
            {/* kvuly spravnemu zarovnani css next tlacitka v pravo bude {page.showBack && uvnitr */}
            <div className="">{showBackButton() && <Button title="zpět" className={"shadow-md"} type="back" onClick={navigateBackButtons} place="left" />}</div>

            {page.showNext && (
              <div className={`col-span-3 ${nextBtnPlaceCss}`}>
                <Button type="primary" className={"shadow-md"} title={page.nextTitle} showIcon={page.showNextIcon} onClick={() => validate(index)} />
              </div>
            )}
          </div>
        </footer>
      )}
      {showFooter && isTerminal && (
        <footer className="">
          <div className="grid">
            {showNext && page.showNext && (
              <div className={`col-span-3 w-full ${nextBtnPlaceCss}`}>
                <Button
                  type="terminal"
                  className={"w-full h-20 rounded-none text-3xl"}
                  title={page.nextTitle}
                  showIcon={page.showNextIcon}
                  onClick={() => validate(index)}
                />
              </div>
            )}

            {showSkip && page.showNext && (
              <div className={`col-span-3 w-full ${nextBtnPlaceCss}`}>
                <Button
                  type="terminal-error"
                  className={"w-full h-20 rounded-none text-3xl"}
                  title={skipText}
                  showIcon={page.showNextIcon}
                  onClick={() => validate(index, true)}
                />
              </div>
            )}
          </div>
        </footer>
      )}
      {showAppInfo && (
        <footer className="w-full">
          <AniamtedFadeBlock>
            <div className={`${getCssFor("grid-footer")} grid justify-items-stretch  mb-0 mt-0`}>
              {!isTerminal && (
                <div className="text-accent-dark font-black text-xs inline-flex">
                  <a href="https://cekarnavmobilu.cz/" className="ml-1">
                    <img src={image} width={getCssFor("img")} />
                  </a>
                </div>
              )}
              {!isTerminal && (
                <div className={`${getCssFor("footer-env-text")} text-secondary font-light justify-self-end`}>
                  verze: {process.env.REACT_APP_VERSION}.{process.env.REACT_APP_BUILD_ID}
                  {getEnv()}
                </div>
              )}
            </div>
          </AniamtedFadeBlock>
        </footer>
      )}

      {isTerminal && <HiddenMenuBar />}
    </div>
  );
};

export default PageWrapper;
